export const getMessagingErrorMessage = (err) => {
  const raw = (err?.message || err?.error_description || '').toString();
  const msg = raw.toLowerCase();

  if (msg.includes('you cannot send messages to this user')) {
    return "You can’t message this user because they have blocked you.";
  }

  if (msg.includes('you have blocked this user')) {
    return "You can’t message this user because you blocked them.";
  }

  if (msg.includes('row-level security') || msg.includes('violates row-level security')) {
    return 'Message could not be sent.';
  }

  return 'Failed to send message. Please try again.';
};

export default getMessagingErrorMessage;
